export default __webpack_public_path__ + "static/media/pantry1-afterH-768w.7ba329f9.webp";